var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCerrarActivo24X24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9861 5.01386C17.2546 5.28235 17.2546 5.71765 16.9861 5.98614L5.98614 16.9861C5.71765 17.2546 5.28235 17.2546 5.01386 16.9861C4.74538 16.7177 4.74538 16.2823 5.01386 16.0139L16.0139 5.01386C16.2823 4.74538 16.7177 4.74538 16.9861 5.01386Z",
    fill: "#212831"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01386 5.01386C5.28235 4.74538 5.71765 4.74538 5.98614 5.01386L16.9861 16.0139C17.2546 16.2823 17.2546 16.7177 16.9861 16.9861C16.7177 17.2546 16.2823 17.2546 16.0139 16.9861L5.01386 5.98614C4.74538 5.71765 4.74538 5.28235 5.01386 5.01386Z",
    fill: "#212831"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCerrarActivo24X24);
export default __webpack_public_path__ + "static/media/LOGO_CERRAR_ACTIVO_24X24.c059c05a973393c90330d3820cf829fb.svg";
export { ForwardRef as ReactComponent };